import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { LazyLoadImage } from "react-lazy-load-image-component";
import moment from "moment";
import numeral from "numeral";
import "./WatchScreen.css";
import request from "../../api";

const SimilarVideos = ({ videoId }) => {
  const [thumbnail, setThumbnail] = useState("https://i.imgur.com/JN4uJ1Y.png");
  const [duration, setDuration] = useState(10000);
  const [videoTitle, setVideoTitle] = useState("My 2021 Wrapped");
  const [viewCount, setViewCount] = useState(10000);
  const [publisedAt, setPublisedAt] = useState("2021-06-6");
  const [channel, setChannel] = useState("Vineeta Jain");

  useEffect(() => {
    const get_video_details = async () => {
      const {
        data: { items },
      } = await request("/videos", {
        params: {
          part: "contentDetails,statistics,snippet",
          id: videoId,
        },
      });

      if (items[0] !== undefined) {
        setThumbnail(items[0]?.snippet?.thumbnails?.default?.url);
        setVideoTitle(items[0]?.snippet?.title);
        setChannel(items[0]?.snippet?.channelTitle);
        setPublisedAt(items[0]?.snippet?.publishedAt);
        setViewCount(items[0]?.statistics?.viewCount);
        setDuration(items[0]?.contentDetails?.duration);
      }
    };

    get_video_details();
  }, [videoId]);

  const seconds = moment.duration(duration).asSeconds();
  const _duration = moment.utc(seconds * 1000).format("mm:ss");

  return (
    <Row className="similarVideo m-1 py-3 align-items-center">
      <Col xs={6} md={4} className="similarVideo-left">
        <LazyLoadImage
          src={thumbnail}
          effect={"blur"}
          className="similarVideo-thumbnail"
        />
        <span className="video_duration">{_duration}</span>
      </Col>
      <Col xs={6} md={8} className="similarVideo-right">
        <p
          className="similarVideo-title mb-1"
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {videoTitle}
        </p>
        <div className="similarVideo-details">
          <span>
            {numeral(viewCount).format("0.a")} views | &nbsp;
            {moment(publisedAt).fromNow()}
          </span>
        </div>
        <div className="similarVideo-channel">{channel}</div>
      </Col>
    </Row>
  );
};

export default SimilarVideos;
